module.exports = __webpack_public_path__ + "img/nav-vehicle-models-homepage-kia.b8f94f01.png";